// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

import calcfontSizes from "../../utils/calc-font-sizes"

const ratio = 1.3
//const range = [-2, 7]
const range = [-2, 7]
const fontSizes = calcfontSizes(ratio, range)

export default fontSizes
